import { render, staticRenderFns } from "./AdminAreaBranchDetailTabNewSurgeonModal.vue?vue&type=template&id=cbe933dc&scoped=true&"
import script from "./AdminAreaBranchDetailTabNewSurgeonModal.vue?vue&type=script&lang=js&"
export * from "./AdminAreaBranchDetailTabNewSurgeonModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminAreaBranchDetailTabNewSurgeonModal.vue?vue&type=style&index=0&id=cbe933dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe933dc",
  null
  
)

export default component.exports